(function ($) {

	var $spinner = $('.js-spinner');
	var $form = $('#riksbank-seriesform');
	var $resetButton = $('input:reset');
	var $result = $('.result');
	var hasResults = $('.js-has-form-result').length > 0;

	function init() {
		if ($form.length === 0) {
			return;
		}

		$resetButton.click(reloadPage);
		$form.submit(handleSubmit);
		handleResults();
	}

	function reloadPage() {
		location.href = window.location.pathname;
	}

	function handleResults() {
		if (hasResults === false) {
			return;
		}

		$spinner.hide();
		scrollToResult();
	}

	function handleSubmit() {
		$result.html('');
		$spinner.show();
		// TODO: Commenting this line breaks behavior of old Swea, submit doesn't focus on the spinner but we still focus on the result once its loaded.
		// scrollToResult();
	}

	function scrollToResult() {
		var scrollTo = $('.form-button-group').offset().top - 100;

		$('html, body').animate({
			scrollTop: scrollTo
		}, 400);
	}

	init();

})(jQuery);
